module.exports = {
  GraficaD3: {
    PluginName: "Graphic",
    style: "Style",
    margin: "Margin",
    left: "Left",
    right: "Right",
    top: "Top",
    bottom: "Bottom",
    padding: "Padding",
    border_width: "Border Width",
    border_style: "Border Style",
    border_color: "Border Color",
    border_radius: "Border Radius",
    opacity: "Opacity",
    name: "Name",
    axis: "Axis",
    axes_v: "Vertical axis",
    axes_h: "Horizontal axis",
    ring: "Ring",
    rings: "Rings",
    title: "Title",
    edit: "Edit",
    color: "Color",
    grid: "Grid",
    Graph: "Graph",
    number_graphs: "Number of Graphs",
    see_grid: "See grid",
    x_grid: "X axis grid",
    y_grid: "Y axis grid",
    line_color: "Line color",
    file: "Choose File",
    or: "Or",
    x_axis: "X Axis",
    y_axis: "Y Axis",
    chart_type: "Chart Type",
    order_by: "Order By",
    data_rows: "Num. Rows",
    data_cols: "Num. Columns",
    key: "Key",
    value: "Value",
    vertical: "Vertical",
    horizontal: "Horizontal",
    alert_msg: "Fill in all the fields in the table",
    confirm: "Confirm",
    fill_in: "Or fill in a table",
    show: "Show",
    preview: "Preview",
    Row: "Row",
    Column: "Column",
    row_name: "Graphic Name",
    types: {
      line: "Line",
      area: "Area",
      bar: "Bar",
      pie: "Pie",
    },
    header: {
      options: "Chart options",
      origin: "Data source",
      preview: "Preview",
    },
    example: {
      example_name_surname_txt: "Name Surname",
      example_age_txt: "Age",
      example_country_txt: "Country",
      examplename1: "John Doe",
      examplename2: "Mary Smith",
      exampleage1: "16",
      exampleage2: "23",
    },
  },
};
